import { render, staticRenderFns } from "./CollectionItemThumbnail.vue?vue&type=template&id=204bc4b3&scoped=true&"
import script from "./CollectionItemThumbnail.vue?vue&type=script&lang=js&"
export * from "./CollectionItemThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./CollectionItemThumbnail.vue?vue&type=style&index=0&id=204bc4b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204bc4b3",
  null
  
)

export default component.exports